module.exports = __webpack_public_path__ + "img/head.fb33b6a7.jpg";